<app-adminmenu *ngIf="showAdmin"></app-adminmenu>
<router-outlet></router-outlet>